import { lazy } from 'react'
import { createBrowserRouter, Navigate, useLocation } from 'react-router'
import { RootLayout } from '@/components/layout/RootLayout'
import LibraryPage from '@/pages/LibraryPage'
import NotFoundPage from '@/pages/NotFoundPage'
import { RouteError } from '@/pages/RouteError'

// Secondary pages are code-split; RootLayout's Suspense shows a loader while they load.
// The library (homepage) and 404 stay in the main bundle (the 404 is also used by the error boundary).
const GamePage = lazy(() => import('@/pages/GamePage'))
const PrivacyPage = lazy(() => import('@/pages/PrivacyPage'))
const TermsPage = lazy(() => import('@/pages/TermsPage'))

/** `/games` was the library's old address; keep old links and query strings working. */
function RedirectToLibrary() {
  const { search } = useLocation()
  return <Navigate to={{ pathname: '/', search }} replace />
}

export const router = createBrowserRouter([
  {
    Component: RootLayout,
    children: [
      {
        // Pathless route so errors render inside the site header/footer.
        ErrorBoundary: RouteError,
        children: [
          { index: true, Component: LibraryPage },
          { path: 'games', Component: RedirectToLibrary },
          { path: 'games/:gameId', Component: GamePage },
          { path: 'privacy', Component: PrivacyPage },
          { path: 'terms', Component: TermsPage },
          { path: '*', Component: NotFoundPage },
        ],
      },
    ],
  },
])
